<template lang="pug">
  p.pdp-best-match.text-left.text-color-1.xs-f-small.lg-f-medium.max-at-tweak(v-if="bestMatchName") Your best match is {{bestMatchName}}

</template>

<script>
  import bestMatchMixin from '@mixins/bestMatchMixin';

  export default {
    name: "PdpBestMatch",
    mixins: [bestMatchMixin],
    props: {
      productType: {
        type: String,
        default: 'color_kit',
        required: true
      }
    },
    computed: {
      bestMatchName() {
				return this.mix_bestMatchName(this.productType);
			},
    }
  };
</script>

<style scoped lang="stylus">
  .pdp-best-match
    position relative
    padding 1em 10px
    padding-right 3.5em
    display block
    width 100%
    background-color color-pale-blue
    border-radius 0.25em

	@media mq-tablet-less
		.pdp-best-match
			padding 1em 10%

</style>
